import { UserGlobalFilter } from "../models/UserModel/UserGlobalFilter";

interface DefaultableItem {
  id?: string;
  isDefault?: boolean;
}

// Location and Customer are company-scoped, so they never fall back to an IsDefault row.
const NO_IS_DEFAULT_FALLBACK = ["locationId", "customerId"];

/**
 * Resolves the value to prefill on a new ticket for a lookup field.
 * The user's global filter wins when its value is in `items`; otherwise the IsDefault row is used.
 */
export const resolveDefaultId = (
  fieldName: string,
  items: DefaultableItem[],
  globalFilters: UserGlobalFilter[] | undefined
): string | undefined => {
  // Global filter FieldName is PascalCase ("DepartmentId"), form field names are camelCase.
  // Duplicate rows per field are possible (no unique index), so the first one is used.
  const filterValue = globalFilters?.find((f) => f.fieldName.toLowerCase() === fieldName.toLowerCase())?.value;
  const fromFilter = filterValue ? items.find((i) => i.id?.toLowerCase() === filterValue.toLowerCase())?.id : undefined;

  if (fromFilter) return fromFilter;
  if (NO_IS_DEFAULT_FALLBACK.includes(fieldName)) return undefined;
  return items.find((i) => i.isDefault)?.id;
};
